import _ from 'lodash';

import { DisplayMoney } from '@tock/money';
import { PriceDistribution } from 'generated/graphql';
import { consumer } from '@tock/coretypes';
import ConsumerDisplayMoney from 'components/ConsumerDisplayMoney';

export function isZero(price?: consumer.IPriceRange | null): boolean {
  if (_.isNil(price)) {
    return true;
  }
  return price.minCents === price.maxCents && price.minCents === 0;
}

export function getUnitLabel(priceDistribution: PriceDistribution): string {
  return priceDistribution === 'PER_PARTY' ? 'party' : 'person';
}

interface RenderRangeProps {
  text: string;
  price?: consumer.IPriceRange | null;
}

export const isPriceRange = (price?: consumer.IPriceRange | null) => {
  if (isZero(price) || _.isNil(price)) {
    return false;
  }

  return !(price.minCents === price.maxCents);
};

export const RenderRange = ({ text, price }: RenderRangeProps) => {
  if (isZero(price) || _.isNil(price)) {
    return null;
  }

  if (!isPriceRange(price)) {
    return (
      <span>
        <ConsumerDisplayMoney amount={price.maxCents} roundIfWholeNumber={true} /> {text}
      </span>
    );
  }

  return (
    <span>
      <DisplayMoney amount={price.minCents} roundIfWholeNumber={true} />
      &ndash;
      <DisplayMoney amount={price.maxCents} roundIfWholeNumber={true} /> {text}
    </span>
  );
};

export const isPaymentCardHoldExperience = (offering: consumer.IOffering | undefined) => {
  return !!offering?.price?.partyRangeConfigs?.find(
    (config) => config?.ticketPriceInformation?.priceType === 'PAYMENT_CARD_HOLD'
  );
};
